export interface VehicleAction {
  type: string;
}

const vehicle = (state = {}, action: VehicleAction,) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default vehicle;
